import { useState } from 'react';
import { addMinutes, parseLocal, toLocalInputValue } from '@/utils/datetime';
import { DEFAULT_DURATION_MIN } from '@/utils/event';

export function ComposerCard({
  onAdd
}: {
  onAdd: (payload: { title: string; start_ts: string; end_ts: string; location: string }) => Promise<void>;
}) {
  const [title, setTitle] = useState('');
  const [dt, setDt] = useState(() => {
    const now = new Date();
    now.setMinutes(now.getMinutes() + (60 - (now.getMinutes() % 30)));
    return toLocalInputValue(now);
  });
  const [loc, setLoc] = useState('');

  async function tryCommit() {
    const t = title.trim();
    const l = loc.trim();
    if (!t || t.length < 2) return;
    if (!dt || Number.isNaN(new Date(dt).getTime())) return;
    if (!l || l.length < 2) return;

    const start = parseLocal(dt);
    const end = addMinutes(start, DEFAULT_DURATION_MIN);
    await onAdd({ title: t, start_ts: toLocalInputValue(start)+':00', end_ts: toLocalInputValue(end)+':00', location: l });

    // reset + bump
    setTitle('');
    setLoc('');
    const next = addMinutes(start, 60);
    setDt(toLocalInputValue(next));
  }

  function onKey(e: React.KeyboardEvent<HTMLInputElement>) {
    if (e.key === 'Enter') { e.preventDefault(); void tryCommit(); }
    if (e.key === 'Escape') { setTitle(''); setLoc(''); }
  }

  return (
    <article className="card glass" role="form" aria-label="Add new event">
      <div className="card-head">
        <input
          className="editlike name-input"
          placeholder="New event name"
          value={title}
          onChange={(e)=>setTitle(e.target.value)}
          onBlur={tryCommit}
          onKeyDown={onKey}
          style={{ flex: 1, minWidth: 0 }}
        />
      </div>
      <div className="meta-grid">
        <input
          className="editlike dt-input"
          type="datetime-local"
          value={dt}
          onChange={(e)=>setDt(e.target.value)}
          onBlur={tryCommit}
          onKeyDown={onKey}
        />
        <input
          className="editlike loc-input"
          placeholder="Location"
          value={loc}
          onChange={(e)=>setLoc(e.target.value)}
          onBlur={tryCommit}
          onKeyDown={onKey}
        />
      </div>
      <div className="hint">Start typing — it saves automatically.</div>
    </article>
  );
}
